import { cn } from "../../utils/cn.ts";
import { TokenLogo } from "../TokenLogo/index.js";
import { TokenIcon, type TokenName } from "./token-icon.tsx";

interface IProps {
  tokens: TokenName[];
  className?: string;
}

export const TokenPairIcon = ({ tokens, className }: IProps) => {
  return (
    <div className={cn("flex", className)}>
      {tokens.map((token, index) => (
        <TokenLogo key={index} token={token} height={32} width={32} className="relative z-10"
          style={{
            zIndex: index + 1,
            left: index === 0 ? 0 : -8,
          }} />
      ))}
    </div>
  );
};
